import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import User from '@/shared/models/User';
import TimeRegistration from '../models/TimeRegistration';
import TimeRegistrationContainer from '../models/TimeRegistrationContainer';
import { parseJobs } from './jobConverters';

const CONTAINER_SCHEMA = {
  allowedMinutes: 'allowedDuration',
  registeredMinutes: 'timeRegistered',
  minutesPerUnit: 'minutesPerTimeUnit',
  registrations: (data: any) => parseTimeRegistrations(data.timeEntries),
  jobs: (data: any) => parseJobs(data.jobs),
};

const SCHEMA = {
  id: 'id',
  sequenceNumber: 'entryNumber',
  startedBy: (data: any) => User.withId(data.startedBy),
  startedOn: (data: any) => parseMoment(data.startedOn),
  stoppedBy: (data: any) => User.withId(data.stoppedBy),
  stoppedOn: (data: any) => parseMoment(data.stoppedOn),
  jobCount: 'jobCount',
  jobs: (data: any) => parseJobs(data.jobs),
};

export function parseTimeRegistrationContainer(data: any): TimeRegistrationContainer | null {
  return parseEntity(data, CONTAINER_SCHEMA, TimeRegistrationContainer);
}

export function parseTimeRegistrations(data: any): Array<TimeRegistration> {
  return parseEntities(data, SCHEMA, TimeRegistration);
}

export function parseTimeRegistration(data: any): TimeRegistration | null {
  return parseEntity(data, SCHEMA, TimeRegistration);
}